import Box from "@material-ui/core/esm/Box";
import DeleteOutline from "@material-ui/icons/esm/DeleteOutline";
import Cached from "@material-ui/icons/esm/Cached";
import BlockOutlined from "@material-ui/icons/esm/BlockOutlined";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';
import { isObeBeingMoved as isObeBeingMovedSelector } from 'api/obes/getIsObeBeingMoved';
import { SecondaryButton } from 'components/Button';
import InfoBox from 'components/InfoBox/InfoBox';
import { Header, Title } from 'components/Text';
import VehicleInfoCard from 'components/VehicleInfo/VehicleInfo';
import EnumObeStatus from 'constants/obeStatuses';
import { TERMINATE_INACTIVE_TAG } from 'routes/overview/TerminateInactiveTag/paths';
import { TRANSFER_TAG } from 'routes/overview/TransferTag/paths';
import { UNREGISTER_VEHICLE } from 'routes/overview/UnregisterTag/paths';
import { mapGetObeDetailsResult } from 'utils/mapping/mapVehicles';
import isObeActive from 'utils/obes/isObeActive';
import isObeMovable from 'utils/obes/isObeMovable';
import checkLoadable from 'utils/recoil/checkLoadable';
import useStyles from '../TagDetailsStyles';
export default function VehicleInfo({
  tag
}) {
  const {
    t
  } = useTranslation();
  const {
    row
  } = useStyles();
  const {
    push
  } = useHistory();
  const isObeBeingMovedLoadable = useRecoilValueLoadable(isObeBeingMovedSelector(tag?.obeId));
  const {
    contents: isObeBeingMoved
  } = checkLoadable(isObeBeingMovedLoadable);
  if (!tag) return /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('error.no_tag'));
  const {
    registrationNumber,
    obeStatus
  } = tag;
  return /*#__PURE__*/React.createElement(Box, {
    my: 3
  }, /*#__PURE__*/React.createElement(Header, null, t('vehicles.vehicle')), registrationNumber && /*#__PURE__*/React.createElement(VehicleInfoCard, {
    vehicle: mapGetObeDetailsResult(tag)
  }), !isObeBeingMoved && registrationNumber && isObeMovable(tag) && /*#__PURE__*/React.createElement(Box, {
    className: row
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 2
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    startIcon: /*#__PURE__*/React.createElement(Cached, null),
    onClick: () => push(TRANSFER_TAG(tag?.obeNumber))
  }, t('buttons.edit_vehicle'))), /*#__PURE__*/React.createElement(SecondaryButton, {
    startIcon: /*#__PURE__*/React.createElement(DeleteOutline, null),
    onClick: () => push(UNREGISTER_VEHICLE(tag?.obeNumber))
  }, t('buttons.remove_vehicle'))), !isObeBeingMoved && !registrationNumber && /*#__PURE__*/React.createElement(React.Fragment, null, isObeActive(obeStatus) && /*#__PURE__*/React.createElement(Box, {
    className: row,
    mb: 2
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 2
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    onClick: () => push(TRANSFER_TAG(tag?.obeNumber))
  }, t('agreements.register_new_vehicle_on_tag'))), tag.obeStatus === EnumObeStatus.Inactive && /*#__PURE__*/React.createElement(SecondaryButton, {
    startIcon: /*#__PURE__*/React.createElement(BlockOutlined, null),
    onClick: () => push(TERMINATE_INACTIVE_TAG(tag?.obeNumber))
  }, t('terminate_inactive_tag.title'))), /*#__PURE__*/React.createElement(InfoBox, {
    mb: 2
  }, t('vehicles.no_attached_vehicle'))), isObeBeingMoved && /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(InfoBox, {
    warning: true
  }, t('error.is_being_moved'))));
}